export const state = {
    grupoPermissao: {},
    gruposPermissoes: [],
    modalExcluirGrupoPermissao: false,
    modalCadastrarGrupoPermissao: false,
}

export default {}